// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a659d2bc","845":"bc14c52a"}[chunkId] + ".chunk.js";
};